import service from '@/store/services/chat-service';

const state = {
    selectedProRetoucher: null,
    selectedRetoucher: null,
    saveVersionRating: {}
};

const mutations = {
    selectedProRetoucher(state, selectedProRetoucher) {
        state.selectedProRetoucher = selectedProRetoucher;
    },
    selectedRetoucher(state, selectedRetoucher) {
        state.selectedRetoucher = selectedRetoucher;
    },
    SET_SAVE_VERSION_RATING: (state, saveVersionRating) => {
        state.saveVersionRating = saveVersionRating;
    },
};
const actions = {
    async setSelectedProRetoucher({commit}, selectedProRetoucher) {
        commit('selectedProRetoucher', selectedProRetoucher);
    },
    async setSelectedRetoucher({commit}, selectedRetoucher) {
        commit('selectedRetoucher', selectedRetoucher);
    },
    saveVersionRating({commit, dispatch}, params) {
        return service.saveVersionRating(params)
            .then(({saveVersionRating}) => {
                commit('SET_SAVE_VERSION_RATING', saveVersionRating);
            });
    },
};

const getters = {
    selectedProRetoucher: state => state.selectedProRetoucher,
    selectedRetoucher: state => state.selectedRetoucher,
    saveVersionRating: state => state.saveVersionRating
};

const loading = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default loading;